export default __webpack_public_path__ + "static/media/List-documentation.27e98a19.md";